/**
 * Generic frontend error classification kinds.
 * Used by ErrorBox / SpaLevelErrorDisplay for user-facing copy.
 */
export const ErrorKinds = Object.freeze({
  connectivity: "connectivity",
  temporaryInfra: "temporaryInfra",
  unexpectedApp: "unexpectedApp",
  forbidden: "forbidden",
});
